import { useUserSubscriptionProductQuery } from './graphql.generated';

export const useCurrentUserSubscription = () => {
	const { data, loading, error, refetch } = useUserSubscriptionProductQuery();

	return {
		currentUserSubscription: data?.userSubscriptionProduct,
		loading,
		error,
		refetch,
	};
};
